import { Product } from "@cart-app/generated/graphql";

export const mockProduct: Product = {
  id: "241490",
  title: "48 x Cadbury Caramello Egg 39g",
  slug: "3-x-palmolive-naturals-replenishing-soap-bars-milk-honey-90g-4pk-241469",
  sellable: true,
  visible: true,
  variants: [],
  assets: {
    hero: {
      id: "967353",
      url: "https://static.devcat.ch/images/product/0000/0967/551a3125ef298396884344.jpg",
      altText:
        "3 x Palmolive Naturals Replenishing Soap Bars Milk & Honey 90g 4pk",
      height: 540,
      width: 427,
    },
    gallery: [
      {
        id: "967353",
        url: "https://static.devcat.ch/images/product/0000/0967/551a3125ef298396884344.jpg",
        altText:
          "3 x Palmolive Naturals Replenishing Soap Bars Milk & Honey 90g 4pk",
      },
    ],
    sizeCharts: [],
  },
  ratingsSummary: {
    numberOfRatings: 1000,
    averageRating: 4.5,
  },
  options: [],
  bestOffer: {
    catchPromotion: true,
    id: "205057",
    seller: {
      id: "1",
      name: "Catch",
    },
    salesChannel: {
      id: "1",
    },
    clubSellPrice: {
      amount: 692,
      currency: "AUD",
    },
    stockLevel: "HIGH",
    clickAndCollect: true,
    currency: "AUD",
    clubFreeShipping: true,
    clubExclusive: false,
    freeShipping: false,
    variant: {
      id: "4cf5c2a1-e7f3-4453-8e1e-a7540f8ab929",
      sellable: true,
      variantOptionValues: [],
      offers: [],
      inWishlist: false,
      wishlist: {
        inWishlist: false,
      },
      product: {
        id: "241469",
        slug: "3-x-palmolive-naturals-replenishing-soap-bars-milk-honey-90g-4pk-241469",
        sellable: true,
        title:
          "3 x Palmolive Naturals Replenishing Soap Bars Milk & Honey 90g 4pk",
        visible: true,
        variants: [],
        assets: {
          hero: {
            id: "967353",
            url: "https://static.devcat.ch/images/product/0000/0301/54fe7649d05ab977273390.jpg",
            altText: "48 x Cadbury Caramello Egg 39g",
            height: 540,
            width: 427,
          },
          gallery: [
            {
              id: "967353",
              url: "https://static.devcat.ch/images/product/0000/0301/54fe7649d05ab977273390.jpg",
              altText: "48 x Cadbury Caramello Egg 39g",
            },
          ],
          sizeCharts: [],
        },
        ratingsSummary: {
          numberOfRatings: 1000,
          averageRating: 4.5,
        },
        options: [],
        fromPriceLabel: true,
        sensitive: false,
        adult: false,
        ageRestricted: false,
      },
    },
    purchasableQuantity: 10,
    sellPrice: {
      amount: 899,
      currency: "AUD",
    },
    originPrice: {
      amount: 699,
      currency: "AUD",
    },
  },
  fromPriceLabel: true,
  sensitive: false,
  adult: false,
  ageRestricted: false,
};
